<body>
  <!-- <h3 class="">Match Score</h3> -->
  <h4 style="color: var(--text-main);">{{ leagueName | titlecase }}</h4>
  <div class="global-error-box" *ngIf="hasValidationErrors()">
    <ul>
      <li *ngFor="let msg of getValidationMessages()">{{ msg }}</li>
    </ul>
  </div>
  <div *ngFor="let match of matches; let i = index" class="match-block">
    <table class="score-table">
      <thead>
        <tr>
          <th>Players</th>
          <th>Set 1</th>
          <th>Set 2</th>
          <th>Set 3</th>
          <th>Default</th>
          <th>Retired</th>
        </tr>
      </thead>
      <tbody>
        <!-- Team 1 -->
        <tr>
          <td>
            <select [(ngModel)]="match.team1.player1" (change)="checkDuplicatePlayers()" [disabled]="areFieldsDisabled">
              <option [ngValue]="null" disabled selected>Select Player</option>
              <option *ngFor="let player of homeTeamPlayers" [ngValue]="player">
                {{ player.userName }}
              </option>
            </select>
            <ng-container *ngIf="match.isDoubles">
              /
              <select [(ngModel)]="match.team1.player2" (change)="checkDuplicatePlayers()" [disabled]="areFieldsDisabled">
                <option [ngValue]="null" disabled selected>Select Player</option>
                <option *ngFor="let player of homeTeamPlayers" [ngValue]="player">
                  {{ player.userName }}
                </option>
              </select>
            </ng-container>
          </td>
          <td>
            <input type="number" [(ngModel)]="match.team1.set1"  [disabled]="areFieldsDisabled" min="0" max="7"
             (input)="onScoreInput(match, 'set1', match.team1.set1, match.team2.set1, awaySet1,i)"
            #homeSet1/>
          </td>
          <td>
            <input type="number" [(ngModel)]="match.team1.set2" [disabled]="areFieldsDisabled" min="0" max="7"
            (input)="onScoreInput(match, 'set2', match.team1.set2, match.team2.set2, awaySet2,i)"
       #homeSet2 />
          </td>
          <td>
            <input type="number" [(ngModel)]="match.team1.set3"  [disabled]="areFieldsDisabled" min="0" max="7"
            (input)="onScoreInput(match, 'set3', match.team1.set3, match.team2.set3, awaySet3,i)"
       #homeSet3/>
          </td>
          <td><input type="checkbox" [(ngModel)]="match.team1.default"  [disabled]="areFieldsDisabled"   (change)="handleCheckboxChange(match, 1, 'default')"/></td>
          <td><input type="checkbox" [(ngModel)]="match.team1.retired"  [disabled]="areFieldsDisabled"   (change)="handleCheckboxChange(match, 1, 'retired')"/></td>
        </tr>

        <!-- Team 2 -->
        <tr>
          <td>
            <select [(ngModel)]="match.team2.player1" (change)="checkDuplicatePlayers()" [disabled]="areFieldsDisabled">
              <option [ngValue]="null" disabled selected>Select Player</option>
              <option *ngFor="let player of awayTeamPlayers" [ngValue]="player">
                {{ player.userName }}
              </option>
            </select>
            <ng-container *ngIf="match.isDoubles">
              /
              <select [(ngModel)]="match.team2.player2" (change)="checkDuplicatePlayers()" [disabled]="areFieldsDisabled">
                <option [ngValue]="null" disabled selected>Select Player</option>
                <option *ngFor="let player of awayTeamPlayers" [ngValue]="player">
                  {{ player.userName }}
                </option>
              </select>
            </ng-container>
          </td>
          <td>
            <input type="number" [(ngModel)]="match.team2.set1"  [disabled]="areFieldsDisabled" min="0" max="7"
            (input)="onScoreInput(match, 'set1', match.team1.set1, match.team2.set1, homeSet2, i)"
            #awaySet1/>
          </td>
          <td>
            <input type="number" [(ngModel)]="match.team2.set2"  [disabled]="areFieldsDisabled" min="0" max="7"
           (input)="onScoreInput(match, 'set2', match.team1.set2, match.team2.set2, homeSet3, i)"

            #awaySet2/>
          </td>
          <td>
            <input type="number" [(ngModel)]="match.team2.set3"  [disabled]="areFieldsDisabled" min="0" max="7"
(input)="onScoreInput(match, 'set3', match.team1.set3, match.team2.set3, null, i)"
            #awaySet3 />
          </td>
          <td><input type="checkbox" [(ngModel)]="match.team2.default"  [disabled]="areFieldsDisabled"   (change)="handleCheckboxChange(match, 2, 'default')"/></td>
          <td><input type="checkbox" [(ngModel)]="match.team2.retired"  [disabled]="areFieldsDisabled"   (change)="handleCheckboxChange(match, 2, 'retired')"/></td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <div style="text-align: center; margin-top: 20px;">
    <button class="submit-btn " (click)="goBack()">Back</button>

 <button (click)="submit()" class="submit-btn m-3" [disabled]="isSubmitDisabled">{{ submitButtonText }}</button>


    <button type="button" class="submit-btn "
          [disabled]="!isEditEnabled" 
          (click)="enableForm()">
    Edit
  </button>
    <!-- <button (click)="submit()" class="submit-btn" [disabled]="!isFormValid || matches.length === 0">Submit</button> -->
    
  </div>


</body>
